exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-more[data-v-6f8c7f28]:hover {\n  cursor: pointer;\n}", ""]);

// exports
